import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CreditCard, Star, FileText, Zap, BookOpen } from 'lucide-react';
import { Button } from '../ui/Button';
const ProductMockup = () => {
  return <motion.div initial={{
    opacity: 0,
    y: 30,
    scale: 0.95
  }} animate={{
    opacity: 1,
    y: 0,
    scale: 1
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} className="relative w-full max-w-[640px] mx-auto" data-id="element-85">
      <img src="https://cdn.magicpatterns.com/uploads/e8xXPhhNPJ6ysxpvuSjFmC/Captura_de_pantalla_2026-05-26_a_la(s)_9.20.55_p._m..png" alt="Megapack PATÍN 360 — Pack Anual Elite Completo" className="w-full h-auto" data-id="element-86" />
    </motion.div>;
};
export const Hero = () => {
  return <section className="overflow-hidden" data-id="element-87">
      {/* SECTION 1 - HERO - Light cream background, centered single column, generous spacing */}
      <div className="bg-[#FAF5EE] text-brand-950 pt-10 md:pt-16 pb-12 md:pb-20 px-5 md:px-4 relative" data-id="element-88">
        <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-89">
          {/* Eyebrow */}
          <motion.div initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="mb-5 md:mb-6" data-id="element-90">
            <span className="inline-block text-[#C66E4F] text-xs md:text-sm font-bold tracking-[0.3em] uppercase" data-id="element-91">
              PROFE LISTO · PATÍN 360
            </span>
          </motion.div>

          {/* Bold black headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.1
        }} className="font-heading text-[40px] sm:text-5xl md:text-6xl lg:text-[80px] font-extrabold leading-[1.02] tracking-tight text-brand-950 mb-6 md:mb-8" data-id="element-92">
            Todo tu año de patín resuelto de una vez.
          </motion.h1>

          {/* Product Mockup */}
          <div className="my-6 md:my-10 flex justify-center" data-id="element-93">
            <div className="w-full max-w-[340px] sm:max-w-[440px] md:max-w-[600px]" data-id="element-94">
              <ProductMockup data-id="element-95" />
            </div>
          </div>

          {/* Subtitle */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-sm md:text-lg text-gray-600 mb-7 md:mb-10 max-w-xl mx-auto leading-relaxed px-2" data-id="element-96">
            Megapack PATÍN 360 — El sistema completo de ejercicios y
            planificación para el profesor de patín artístico argentino
          </motion.p>

          {/* Pill badges with separators on both mobile and desktop */}
          <div className="flex flex-wrap items-center justify-center gap-2 mb-7 md:mb-10" data-id="element-97">
            <div className="inline-flex items-center gap-1.5 md:gap-2 bg-white border border-gray-200 text-brand-950 font-semibold text-xs md:text-sm py-2 md:py-2.5 px-3.5 md:px-5 rounded-full shadow-sm" data-id="element-98">
              <FileText className="w-3.5 h-3.5 md:w-4 md:h-4 text-gray-600" data-id="element-99" />
              <span data-id="element-100">📄 PDF</span>
            </div>
            <span className="text-gray-300" data-id="element-101">|</span>
            <div className="inline-flex items-center gap-1.5 md:gap-2 bg-white border border-gray-200 text-brand-950 font-semibold text-xs md:text-sm py-2 md:py-2.5 px-3.5 md:px-5 rounded-full shadow-sm" data-id="element-102">
              <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 text-amber-500" data-id="element-103" />
              <span data-id="element-104">Acceso Inmediato</span>
            </div>
            <span className="text-gray-300" data-id="element-105">|</span>
            <div className="inline-flex items-center gap-1.5 md:gap-2 bg-white border border-gray-200 text-brand-950 font-semibold text-xs md:text-sm py-2 md:py-2.5 px-3.5 md:px-5 rounded-full shadow-sm" data-id="element-106">
              <BookOpen className="w-3.5 h-3.5 md:w-4 md:h-4 text-gray-600" data-id="element-107" />
              <span data-id="element-108">12 Tomos + 6 Bonus + 2 Élite</span>
            </div>
          </div>

          {/* Coral CTA */}
          <div className="flex flex-col items-center gap-4 md:gap-5" data-id="element-109">
            <motion.a href="#precios" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full sm:w-auto inline-flex items-center justify-center bg-[#D4856A] hover:bg-[#C06E52] text-white font-bold text-base md:text-xl py-4 md:py-5 px-8 md:px-12 rounded-2xl shadow-lg transition-colors" data-id="element-110">
              💪 QUIERO MI PATÍN 360 AHORA
            </motion.a>

            <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 text-[11px] md:text-sm text-gray-600 font-medium mt-1 md:mt-2" data-id="element-111">
              <div className="flex items-center gap-1.5" data-id="element-112">
                <ShieldCheck className="w-3.5 h-3.5 md:w-4 md:h-4 text-[#C66E4F]" data-id="element-113" />
                Garantía 7 días
              </div>
              <span className="text-gray-300" data-id="element-114">|</span>
              <div className="flex items-center gap-1.5" data-id="element-115">
                <Lock className="w-3.5 h-3.5 md:w-4 md:h-4 text-[#C66E4F]" data-id="element-116" />
                Pago seguro
              </div>
              <span className="text-gray-300" data-id="element-117">|</span>
              <div className="flex items-center gap-1.5" data-id="element-118">
                <CreditCard className="w-3.5 h-3.5 md:w-4 md:h-4 text-[#C66E4F]" data-id="element-119" />
                Tarjetas y transferencia
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* SECTION 2 - SOCIAL PROOF RÁPIDA */}
      <div className="bg-brand-700 text-white py-6" data-id="element-120">
        <div className="max-w-6xl mx-auto px-4" data-id="element-121">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center md:divide-x md:divide-brand-600" data-id="element-122">
            <div data-id="element-123">
              <div className="text-2xl md:text-3xl font-bold" data-id="element-124">+300</div>
              <div className="text-brand-200 text-sm mt-1" data-id="element-125">profes confían</div>
            </div>
            <div data-id="element-126">
              <div className="text-2xl md:text-3xl font-bold" data-id="element-127">12+6</div>
              <div className="text-brand-200 text-sm mt-1" data-id="element-128">Tomos + Bonus</div>
            </div>
            <div data-id="element-129">
              <div className="text-2xl md:text-3xl font-bold flex items-center justify-center gap-1" data-id="element-130">
                4.9/5 <Star className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-131" />
              </div>
              <div className="text-brand-200 text-sm mt-1" data-id="element-132">calificación</div>
            </div>
            <div data-id="element-133">
              <div className="text-2xl md:text-3xl font-bold" data-id="element-134">🇦🇷</div>
              <div className="text-brand-200 text-sm mt-1" data-id="element-135">Argentina</div>
            </div>
          </div>
        </div>
      </div>

      {/* SECTION 3 - TESTIMONIOS HERO */}
      <div className="bg-[#FAF5EE]" data-id="element-136">
        <div className="max-w-6xl mx-auto px-4 py-16" data-id="element-137">
          <div className="grid md:grid-cols-3 gap-6" data-id="element-138">
            <motion.div whileHover={{
            y: -5
          }} className="bg-white p-6 rounded-2xl shadow-md border border-gray-100" data-id="element-139">
              <div className="flex items-center gap-3 mb-4" data-id="element-140">
                <div className="w-10 h-10 rounded-full bg-brand-100 text-brand-700 font-bold flex items-center justify-center" data-id="element-141">
                  MP
                </div>
                <div data-id="element-142">
                  <div className="font-bold text-gray-900" data-id="element-143">
                    Marcela P., Buenos Aires
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-144">
                    Profesora de Patín Artístico en Club Propio
                  </div>
                </div>
              </div>
              {/* 5 stars */}
              <div className="flex items-center gap-0.5 mb-3" data-id="element-145">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-146" />)}
              </div>
              <p className="text-gray-700 italic" data-id="element-147">
                "Organicé todo el mes en una tarde. Nunca más llego al club sin
                saber qué dar."
              </p>
            </motion.div>

            <motion.div whileHover={{
            y: -5
          }} className="bg-white p-6 rounded-2xl shadow-md border border-gray-100" data-id="element-148">
              <div className="flex items-center gap-3 mb-4" data-id="element-149">
                <div className="w-10 h-10 rounded-full bg-brand-100 text-brand-700 font-bold flex items-center justify-center" data-id="element-150">
                  CG
                </div>
                <div data-id="element-151">
                  <div className="font-bold text-gray-900" data-id="element-152">
                    Carolina G., Córdoba
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-153">
                    Profesora de Patín en Academia Privada
                  </div>
                </div>
              </div>
              {/* 5 stars */}
              <div className="flex items-center gap-0.5 mb-3" data-id="element-154">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-155" />)}
              </div>
              <p className="text-gray-700 italic" data-id="element-156">
                "Mis alumnos iniciales progresaron de forma visible desde la
                primera semana con el Tomo 1. Los padres me lo empezaron a
                agradecer."
              </p>
            </motion.div>

            <motion.div whileHover={{
            y: -5
          }} className="bg-white p-6 rounded-2xl shadow-md border border-gray-100" data-id="element-157">
              <div className="flex items-center gap-3 mb-4" data-id="element-158">
                <div className="w-10 h-10 rounded-full bg-brand-100 text-brand-700 font-bold flex items-center justify-center" data-id="element-159">
                  FR
                </div>
                <div data-id="element-160">
                  <div className="font-bold text-gray-900" data-id="element-161">
                    Fernando R., Rosario
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-162">
                    Profesor de Patín Independiente
                  </div>
                </div>
              </div>
              {/* 5 stars */}
              <div className="flex items-center gap-0.5 mb-3" data-id="element-163">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-164" />)}
              </div>
              <p className="text-gray-700 italic" data-id="element-165">
                "Antes tardaba 2 horas armando la clase del miércoles. Ahora son
                5 minutos."
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
};